import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetTrialInstitutionIdentityByIdRequest,
    GetTrialInstitutionIdentityByIdResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<
        GetTrialInstitutionIdentityByIdResponse,
        GetTrialInstitutionIdentityByIdResponse
    >,
) => response?.data?.trialInstitutionIdentity;
const getError = (
    response?: SWRResponse<
        GetTrialInstitutionIdentityByIdResponse,
        GetTrialInstitutionIdentityByIdResponse
    >,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<
        GetTrialInstitutionIdentityByIdResponse,
        GetTrialInstitutionIdentityByIdResponse
    >,
) => ({});

const useTrialInstitutionIdentityById = (
    id?: number | null | undefined,
    configuration?:
        | SWRConfiguration<
              GetTrialInstitutionIdentityByIdResponse,
              GetTrialInstitutionIdentityByIdResponse
          >
        | null
        | undefined,
) => {
    const getRequest = useMemo(() => {
        if (!id) return undefined;

        return (): IReturn<GetTrialInstitutionIdentityByIdResponse> =>
            new GetTrialInstitutionIdentityByIdRequest({ id });
    }, [id]);

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useTrialInstitutionIdentityById;
